import {useEffect, useState} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import Logger from '@nl/logger';
import {loadScript, loadScripts} from '../utils/utils';
import {event, EVENT_TYPES} from '../utils/event';

const useAdInitialization = () => {
	const {
		enabled,
		WMUserConsentConfig,
		WMUserConsentLibrary,
		target,
		libraries,
		isRequested,
		country,
	} = useSelector((state) => ({
		enabled: state.config.data.AD_FUEL.enabled,
		WMUserConsentConfig: state.config.data.AD_FUEL.WMUserConsentConfig,
		WMUserConsentLibrary: state.config.data.AD_FUEL.WMUserConsentLibrary,
		target: state.config.data.AD_FUEL.target,
		libraries: state.config.data.AD_FUEL.libraries,
		isRequested: state.config.isRequested,
		country: state.client.data.country,
	}), shallowEqual);
	const [isAdFuelReady, setAdFuelReady] = useState(false);
	const {pathname} = useLocation();

	useEffect(() => {
		const setPageLevelTarget = (nbaDetail) => {
			if (isAdFuelReady) {
				if (nbaDetail && nbaDetail.categoryPrimary && nbaDetail.categoryPrimary.adfuelTarget) {
					window.AdFuel.addPageLevelTarget('category', nbaDetail.categoryPrimary.adfuelTarget);
				} else {
					window.AdFuel.removePageLevelTarget('category');
				}
			}
		};
		if (isAdFuelReady && window.AdFuel && pathname.indexOf('/video/') !== 0) {
			setPageLevelTarget();
		}
		event.on(EVENT_TYPES.VIDEO_DETAIL_NBA_FEED_READY, setPageLevelTarget);
		return () => {
			event.off(EVENT_TYPES.VIDEO_DETAIL_NBA_FEED_READY, setPageLevelTarget);
		};
	}, [pathname, isAdFuelReady]);

	useEffect(() => {
		const initUserConsent = () => {
			if (window.WM && window.WM.UserConsent) {
				window.WM.UserConsent.init({...WMUserConsentConfig, countryCode: country || 'US'});
			}
			return Promise.resolve();
		};
		const initAdFuel = () => {
			if (window.AdFuel && target) {
				// window.AdFuel.addPageLevelTarget('status', target);
				setAdFuelReady(true);
			}
		};

		if (isRequested && enabled) {
			try {
				loadScript(WMUserConsentLibrary)
						.then(initUserConsent)
						.then(() => loadScripts(libraries))
						.then(initAdFuel)
						.catch((err) => {
							Logger.warn('ad fuel init error:', err);
						});
			} catch (err) {
				Logger.warn('ad fuel init error:', err);
			}
		}
	}, [isRequested, enabled, target, libraries, country, WMUserConsentLibrary, WMUserConsentConfig]);
};

export default useAdInitialization;
